
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-basic-hero--content{
  color:white;
  display:flex;
  flex-direction:column;
  padding:2rem 1rem;
  gap:1rem;
  width:100%;
  z-index:1;
}

  @media (min-width: 768px){.se-basic-hero--content{
    padding:5rem 0;
    gap:1.5rem;
    max-width:550px
}
  }

se-container{
  width:100%;
}

.se-basic-hero--description{
  font-size:var(--fs-lg-mobile);
  line-height:var(--lh-lg-mobile);
}

@media (min-width: 768px){

.se-basic-hero--description{
    font-size:var(--fs-lg);
    line-height:var(--lh-lg)
}
  }
`;